import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.css']
})
export class HeroComponent implements OnInit {

  @Input() homeHero_params: any = {}



  preTitle: string = "";

  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.homeHero_params.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.homeHero_params.urlVideo);
  }

}
